import {processAcrissCodes} from '../GetUrlParams';

// Improvement row C2 — the widget must not collapse while a search is in flight.
//
// On phones the widget's only floor is the shortcode root's 560 px (the 100 vh rule is
// desktop-only and the Divi wrapper's 3,320 px reservation is released at mount), so
// when the result list unmounts for a search, everything below the widget — the
// reviews section `#wpcontent3` first — jumps up by thousands of pixels and back down
// when the results render. Two things stop that: SearchResultsContainer holds the
// results area at its previous height during a fetch, and a landing whose URL will
// run a search on its own never renders the sample results first (that pair of jumps
// happened at load, before any input). The helpers here are the URL decision and the
// host-page reservation release.

// Mirrors the parameters App turns into a startup search: an explicit city or point,
// dates or an offset, a vehicle or model deep link, a coupon (?code= / ?vip=) or a body-type filter
// (the last two search Helsinki when the session has no location). Read BEFORE App renders:
// App strips these from the address bar as it reads them.
// `hours` is listed ahead of App: PR #160 (row U10) makes a valid ?hours= a date that searches
// Helsinki. Until it lands App ignores ?hours=, so such a landing gets the samples back from App
// (no location → restored) a moment after mount instead of at it — never a blank widget.
export function urlTriggersStartupSearch(search: string, shortcodeCity?: string): boolean {
    const p = new URLSearchParams(search);
    const has = (name: string) => (p.get(name) ?? '').trim() !== '';
    // The WordPress shortcode can carry a city of its own (`city="…"`); App geocodes it like ?city=.
    if ((shortcodeCity ?? '').trim() !== '') return true;
    return has('city') || (has('lat') && has('lon')) || has('startdate') || has('enddate')
        || has('startoffset') || has('days') || has('hours') || has('carid') || has('modelid')
        || has('code') || has('vip')
        // App ignores an ?acriss= with no known code, so only a usable one searches
        || processAcrissCodes(p.get('acriss') ?? undefined) !== undefined;
}

// The WordPress page reserves 3,320 px around the widget (`#rrmid { min-height }`) so the
// page does not shift while the widget boots. The widget releases it once it shows
// something: the sample results at mount (dataContext), or — on a landing that skipped
// them — the first completed search, here.
export function releaseHostReservation(doc: Document = document) {
    const host = doc.getElementById('rrmid');
    if (host && host.style.minHeight !== 'auto') host.style.minHeight = 'auto';
}
